export function soloLetras(event) {
    if (!/[a-zA-ZáéíóúÁÉÍÓÚñÑ'\s]/.test(event.key)) {
      event.preventDefault();
    }
}